import { FormControl } from "@angular/forms";
import { messages } from "../resources/messages";

export const firstnameEmpty = (control: FormControl) => {
    if (!control.value || control.value.length === 0) {
        return { firstnameEmpty: messages.validation.firstNameEmpty };
    }
};
